import { render, staticRenderFns } from "./CardBodySingleChipNew.vue?vue&type=template&id=b4e3896a&scoped=true"
import script from "./CardBodySingleChipNew.vue?vue&type=script&lang=ts"
export * from "./CardBodySingleChipNew.vue?vue&type=script&lang=ts"
import style0 from "./CardBodySingleChipNew.vue?vue&type=style&index=0&id=b4e3896a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e3896a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4e3896a')) {
      api.createRecord('b4e3896a', component.options)
    } else {
      api.reload('b4e3896a', component.options)
    }
    module.hot.accept("./CardBodySingleChipNew.vue?vue&type=template&id=b4e3896a&scoped=true", function () {
      api.rerender('b4e3896a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CardBodySingleChipNew.vue"
export default component.exports